module.exports = __webpack_public_path__ + "static/blog-breadcrumb-44406e9db4dc3efabde39da997ad6e90.jpg";